import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT } from '../utils/dateOfBirthValidation';

export function getPostInitialValues(commissionList, editFlag) {

  // let startDate = moment(new Date()).format(FORMAT)
  let startDate = moment(new Date().setMonth(new Date().getMonth() - 1)).format(FORMAT);
  let endDate = moment(new Date().setMonth(new Date().getMonth() + 1)).format(FORMAT);


  let commissionOrder
  if(commissionList?.commissionOrderType === "Per Order"){
    commissionOrder ="PER_ORDER"
  }
  if(commissionList?.commissionOrderType === "One Time"){
    commissionOrder ="ONE_TIME"
  }
  // let addLocationInput
  // if(commissionList?.commissionMode === "Per Order"){
  //   addLocationInput ="PER_ORDER"
  // }
  // if(commissionList?.commissionMode === "One Time"){
  //   addLocationInput ="ONE_TIME"
  // }

  return {  
    addLocationInput:editFlag ? commissionList?.commissionType:'INTERNAL',
    name: editFlag ? commissionList?.name:'',
    companyName:editFlag ? commissionList?.companyName:'',
    email:editFlag ? commissionList?.email:'',
    role:editFlag ? commissionList?.role:'',
    commissionMode:editFlag ? commissionList?.commissionMode:'PERCENTAGE',
    // commissionValue:editFlag ? commissionList?.commissionValue:'',
    // minTransValue:editFlag ? commissionList?.minTransValue:'',
    // orderType:editFlag ? commissionOrder:'PER_ORDER',

    commissionValue:editFlag ? commissionList?.commissionMode ==="PERCENTAGE"? commissionList?.commissionValue+'%': '$'+commissionList?.commissionValue:'',
    minTransValue:editFlag ? '$'+commissionList?.minTransValue:'',
    orderType:editFlag ? commissionOrder:'PER_ORDER',
    commissionStartDate:editFlag ? commissionList?.startDate: startDate,
    commissionEndDate:editFlag ? commissionList?.endDate: endDate
  };
}

const VALIDATION_SCHEMA = () => {
      let schemaAttributes = {
        name:Yup.string().trim().required('Name is required.'),
        //companyName:Yup.string().trim().required('Company Name is required.'),
        //role:Yup.string().trim().required('Role is required.'),
        commissionValue:Yup.string().trim().required('Commission value is required.'),
        minTransValue:Yup.string().trim().required('Minimum trans value is required.'),
        email: Yup.string().email('Please enter a valid email.').required('Email is required.'),
      };
      return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };
